export enum RateListingPreset {
    DEFAULT = 'default',
    BY_DISTRICT = 'byDistrict',
    BY_SOURCE_FILE = 'bySourceFile',
    BY_COMPETITOR = 'byCompetitor',
}
